@defer(on viewport) {
<section class="max-w-[1160px] mx-auto">
  <header class="text-center">
    <h2 class="h3-responsive font-bold mb-4">
      <p>We're here to help you</p>
    </h2>
  </header>
  <section class="office flex flex-col gap-24 md:gap-0 md:flex-row items-center justify-between !mt-16 mb-24">
    @for (itm of officeInfos; track $index) {
    <icon-title-desc>
      <a image [attr.href]="itm.link" class="curser-pointer">
        <img [ngSrc]="itm.imageLink" alt="icon" width="75" height="75" />
      </a>
      <div title>
        <a class="curser-pointer font-bold h6-responsive text-primary" [attr.href]="itm.link">
          {{ itm.title }}
        </a>
      </div>
      <p description class="h6-responsive font-thin text-gray-500">
        {{ itm.description }}
      </p>
    </icon-title-desc>
    }
  </section>

  <section class="flex flex-col md:flex-row gap-10 justify-center items-center">
    <img class="office-image w-5/6 sm:w-2/5" ngSrc="assets/images/monisfer_office_1.jpg" alt="Monisfer office" width="455" height="340" />
    <img class="office-image w-5/6 sm:w-2/5" ngSrc="assets/images/monisfer_office_2.jpg" alt="Monisfer office" width="455" height="340" />
  </section>
</section>
}@placeholder {
<div class="spinner-center">
  <mat-spinner></mat-spinner>
</div>
}
